import { useTLang } from 'intl/intl';

export function useCustomizationsGroupsLang() {
  return {
    customGroup: {
      secondary: {
        label: useTLang({ id: 'menuPage.customsGroups.secondary.label' }),
      },
    },
  };
}
